import { render } from "./Grume.vue?vue&type=template&id=fe942584"
import script from "./Grume.vue?vue&type=script&lang=js"
export * from "./Grume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__